<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg4299"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs4303"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath4337"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path4335" /></clipPath></defs><g
     id="g4305"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g4307"
       transform="translate(378.8047,81.8174)"><path
         d="M 0,0 -50.41,29.865"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4309" /></g><g
       id="g4311"
       transform="translate(347.4365,59.1836)"><path
         d="M 0,0 -37.143,22.005"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4313" /></g><g
       id="g4315"
       transform="translate(309.4209,40.4883)"><path
         d="M 0,0 -14.555,8.622"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4317" /></g><g
       id="g4319"
       transform="translate(89.7432,366.6777)"><path
         d="M 0,0 H 245.224"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4321" /></g><g
       id="g4323"
       transform="translate(89.7432,418.9307)"><path
         d="M 0,0 H 122.612"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4325" /></g><g
       id="g4327"
       transform="translate(89.7432,320.3789)"><path
         d="M 0,0 H 245.224"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4329" /></g><g
       id="g4331"><g
         id="g4333"
         clip-path="url(#clipPath4337)"><g
           id="g4339"
           transform="translate(302.9072,502.3916)"><path
             d="M 0,0 V -52.567 C 0,-69.63 13.832,-83.461 30.894,-83.461 h 52.567"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4341" /></g><g
           id="g4343"
           transform="translate(388.4766,280.957)"><path
             d="m 0,0 v 128.279 c 0,6.207 -2.466,12.16 -6.854,16.549 l -71.86,71.86 c -4.39,4.389 -10.343,6.855 -16.55,6.855 H -321.35 c -17.061,0 -30.893,-13.831 -30.893,-30.894 v -397.944 c 0,-17.062 13.832,-30.893 30.893,-30.893 h 78.478"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4345" /></g><g
           id="g4347"
           transform="translate(187.7334,241.1055)"><path
             d="m 0,0 -15.524,9.197 c -4.271,2.531 -9.785,1.119 -12.315,-3.151 l -63.827,-107.737 c -2.53,-4.272 -1.119,-9.785 3.152,-12.315 l 15.525,-9.197 c 10.413,-6.169 23.855,-2.729 30.025,7.684 L 7.685,-30.025 C 13.854,-19.611 10.414,-6.169 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4349" /></g><g
           id="g4351"
           transform="translate(402.0693,165.6572)"><path
             d="m 0,0 23.738,-40.07 c 6.17,-10.413 19.613,-13.854 30.026,-7.685 l 15.525,9.197 c 4.271,2.531 5.682,8.043 3.151,12.315 L 8.613,81.494 c -2.53,4.271 -8.044,5.682 -12.314,3.152 L -19.226,75.448 C -29.639,69.279 -33.08,55.837 -26.91,45.423 l 8.954,-15.114"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4353" /></g><g
           id="g4355"
           transform="translate(284.5107,205.5684)"><path
             d="M 0,0 -2.561,1.516 C -17.287,9.967 -24.174,11.529 -37.46,6.394 L -51.94,0.795 c -8.812,-3.406 -18.7,-2.584 -26.828,2.231 l -8.954,5.28"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4357" /></g><g
           id="g4359"
           transform="translate(141.3135,121.1943)"><path
             d="M 0,0 15.005,-8.856"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4361" /></g><g
           id="g4363"
           transform="translate(267.3232,24.2109)"><path
             d="m 0,0 24.023,-14.232 c 8.425,-4.992 19.301,-2.207 24.292,6.217 4.992,8.425 2.207,19.301 -6.217,24.292 L 62.038,4.464 c 8.426,-4.991 19.302,-2.208 24.293,6.217 4.991,8.424 2.207,19.3 -6.218,24.292 l 13.294,-7.876 c 8.425,-4.991 19.301,-2.207 24.292,6.217 4.991,8.425 2.207,19.301 -6.218,24.292 l 16.27,-9.638 c 8.424,-4.99 19.299,-2.207 24.289,6.217 4.991,8.424 2.208,19.298 -6.216,24.29"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4365" /></g><g
           id="g4367"
           transform="translate(375.9121,209.8086)"><path
             d="m 0,0 -2.088,-1.214 c -8.128,-4.815 -18.016,-5.638 -26.828,-2.231 l -16.33,6.416 c -5.108,2.006 -10.715,2.361 -16.035,1.014 l -25.021,-6.332 c -11.647,-2.947 -19.806,-13.428 -19.806,-25.443 v -33.399 c 0,-4.723 3.827,-8.564 8.549,-8.567 14.241,-0.009 25.788,11.532 25.788,25.771 v 1.414 l 107.097,-63.421 c 1.984,2.113 4.259,3.94 6.761,5.423 l 15.174,8.865"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4369" /></g><g
           id="g4371"
           transform="translate(173.2773,75.5762)"><path
             d="m 0,0 c -5.709,-7.952 -16.784,-9.771 -24.736,-4.062 -7.952,5.709 -9.771,16.785 -4.062,24.737 l 10.04,13.985 c 5.71,7.952 16.784,9.772 24.737,4.062 7.953,-5.709 9.771,-16.784 4.062,-24.736"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4373" /></g><g
           id="g4375"
           transform="translate(223.1973,84.3223)"><path
             d="m 0,0 -21.122,-29.42 c -5.709,-7.953 -16.784,-9.771 -24.736,-4.062 -7.953,5.709 -9.771,16.784 -4.062,24.736 l 21.121,29.421 c 5.71,7.952 16.784,9.77 24.737,4.061 C 3.891,19.027 5.709,7.953 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4377" /></g><g
           id="g4379"
           transform="translate(223.1973,84.3223)"><path
             d="m 0,0 c 5.709,7.953 16.783,9.771 24.735,4.062 7.953,-5.708 9.772,-16.784 4.063,-24.736 L 7.676,-50.095 c -5.709,-7.952 -16.783,-9.77 -24.737,-4.061 -7.952,5.709 -9.77,16.783 -4.061,24.736"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4381" /></g><g
           id="g4383"
           transform="translate(242.6094,50.5752)"><path
             d="m 0,0 c 5.709,7.952 16.784,9.771 24.736,4.062 v 0 c 7.952,-5.709 9.772,-16.784 4.062,-24.736 l -7.024,-9.784 c -5.709,-7.952 -16.783,-9.771 -24.736,-4.062 -7.952,5.709 -9.77,16.785 -4.061,24.737"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4385" /></g></g></g></g></svg>
</template>
